import { h, Component } from 'preact';

import { connect } from 'redux-zero/preact';

const mapToProps = ({ etest, type, pre_test, attempt_of_test }) => ({ etest, type, pre_test, attempt_of_test });
import actions from '../../store/actions';

// Component
import  Level, { LevelBadge } from './Level';
import HidePTResult from './HidePTResult';
import { $lang, allowFromHosts, resultStatus } from '../../plugins/helper';

class PTResult extends Component {
    constructor(props) {
        super(props);
    }

    /** @return {void} */
    backToHome() {
        window.location.href = window.location.href;
    }

    openLevelChart() {
        document.getElementById('level-sidebar').classList.toggle('open');
    }

    /** @return {string} */
    message() {
        const { etest } = this.props;

        switch (resultStatus(etest)) {
            case 'pro_excellent':
                return $lang('pt.result.c1_pro');
            case 'pro_plus_excellent':
                return $lang('pt.result.c1_pro_plus');
            default:
                return null;
        }
    }

    /**
     * check certificate_plan is neojr_plus?
     * @return {boolean}
     **/
    isNeojrPlus() {
        const { etest } = this.props;
        return etest.result.certificate_plan == "neojr_plus"
    }

    /**
     * set grid with coloumns only 3 if certificate plan is neojr_plus
     * @returns {string}
     */
    gridByPlan() {
        return this.isNeojrPlus() ? 'et-grid et-grid-cols-3' : 'et-grid et-grid-cols-4'
    }

    componentDidMount() {
        this.props.addLeaveEvent(false);
    }

    render() {
        const { etest, type, pre_test, attempt_of_test } = this.props;
        if (!etest.is_show_result) return HidePTResult()
        return (
            <div className="et-container et-px-4 et-mx-auto">
                <div className="et-flex et-justify-center et-mb-2">
                    <h2 className="et-level-title">{$lang('level')}</h2>
                </div>
                <div className="et-flex et-justify-center et-mt-2 md:et-mt-0">
                    <div className="etest-level et-h-24 et-w-24 active">
                    <LevelBadge level={etest.result.certificate_level}/>

                    </div>
                </div>
                <div className="et-flex et-justify-center et-my-2">
                    <p className="et-text-center" dangerouslySetInnerHTML={{ __html: this.message() }}></p>
                </div>
                <div className="et-flex et-justify-center et-mt-10">
                    <button onClick={(e) => this.openLevelChart()} class="neo-btn et-cefr-btn">{$lang('pt.cefr_chart')}</button>
                </div>
                <Level etest={etest} />
                <div className="result-correlation et-mt-40">
                    <div className="et-text-xl et-mb-10 et-capitalize et-text-center">
                        {$lang('pt.result_correlation', { level: etest.result.certificate_level })}
                    </div>
                    <div className="relationbox et-max-w-lg et-mx-auto">
                    <div className={this.gridByPlan()}>
                            <div className="et-px-1 md:et-px-3">
                                <div className="neo-card et-rounded-lg">
                                    <div className="neo-card-header et-rounded-t-lg et-text-center content-primary">
                                        <div className="sm:et-text-sm">IELTS</div>
                                    </div>
                                    <div className="neo-card-body et-px-1 et-py-2">
                                        <div className="sm:et-text-sm">{etest.result.ielts === '' ? '-' : etest.result.ielts}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="et-px-1 md:et-px-3">
                                <div className="neo-card et-rounded-lg">
                                    <div className="neo-card-header et-rounded-t-lg et-text-center content-primary">
                                        <div className="sm:et-text-sm">TOEIC</div>
                                    </div>
                                    <div className="neo-card-body et-px-1 et-py-2">
                                        <div className="sm:et-text-sm">{etest.result.toeic === '' ? '-' : etest.result.toeic}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="et-px-1 md:et-px-3">
                                <div className="neo-card et-rounded-lg">
                                    <div className="neo-card-header et-rounded-t-lg et-text-center content-primary">
                                        <div className="sm:et-text-sm">TOEFL iBT</div>
                                    </div>
                                    <div className="neo-card-body et-px-1 et-py-2">
                                        <div className="sm:et-text-sm">{etest.result.toefl === '' ? '-' : etest.result.toefl}</div>
                                    </div>
                                </div>
                            </div>
                            { /* dyned Score not available for neoJr+ */
                            !this.isNeojrPlus() ?
                            <div className="et-px-1 md:et-px-3">
                                <div className="neo-card et-rounded-lg">
                                    <div className="neo-card-header et-rounded-t-lg et-text-center content-primary">
                                        <div className="sm:et-text-sm">CAMBRIDGE</div>
                                    </div>
                                    <div className="neo-card-body et-px-1 et-py-2">
                                        <div className="sm:et-text-sm">{etest.result.dyned === '' ? '-' : etest.result.dyned}</div>
                                    </div>
                                </div>
                            </div>
                            :""}
                        </div>
                    </div>
                </div>
                {
                    allowFromHosts() && pre_test != "true" &&
                    <div className="et-text-center et-mt-20 et-mb-5">
                        <button onClick={() => this.backToHome()} id="neobackhomebutton" className="et-w-8 et-h-8 et-rounded-full et-bg-gray-200 et-relative">
                            <img src="/svg/home.svg" className="et-w-4 et-absolute" style="top:8px; left:8px;" />
                        </button>
                    </div>
                }
            </div>
        )
    }
}

export default connect(mapToProps, actions)(PTResult)